import { Stack } from "@mui/material";
import {
  DatagridConfigurable,
  List,
  NumberField,
  TextField,
  DateField,
  NumberInput,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
  TopToolbar,
  FilterButton,
  CreateButton,
} from "react-admin";
import { ContactEmpty } from "./ContactEmpty";

const filters = [
  <NumberInput source="codigo_sku" label="Código SKU" />,
  <ReferenceInput
    source="id_comprador"
    reference="buyers"
    perPage={100}
    sort={{ field: "id", order: "ASC" }}
    label="Comprador"
    fullWidth
  >
    <SelectInput optionText="nome_razao" />
  </ReferenceInput>,
  <ReferenceInput source="id_fornec" reference="suppliers" label="Fornecedor">
    <AutocompleteInput
      sx={{ width: "300px" }}
      optionText="nome_fornec"
      filterToQuery={(pesquisa) => ({ pesquisa })}
      label="Fornecedor"
    />
  </ReferenceInput>,
  <NumberInput source="id" label="ID" />,
  <NumberInput source="numero_oc" label="Nº OC" />,
];

const ScmAnalysesctions = () => {
  return (
    <TopToolbar>
      <FilterButton disableSaveQuery />
      <CreateButton variant="contained" />
    </TopToolbar>
  );
};

export function ScmAnalysesList() {
  return (
    <Stack gap={4}>
      <List
        filters={filters}
        sort={{ field: "dthr_criacao", order: "DESC" }}
        perPage={50}
        exporter={false}
        empty={false}
        actions={<ScmAnalysesctions />}
      >
        <DatagridConfigurable
          sx={{
            "& .column-descricao": { width: "100px" },
          }}
          empty={<ContactEmpty inline />}
        >
          <NumberField
            source="id"
            label="ID"
            options={{ useGrouping: false }}
          />
          <TextField source="desc_analise" label="Descrição" />
          <DateField source="dthr_criacao" showTime label="Dt/Hr Criação" />
          <NumberField
            source="numero_oc"
            label="OC"
            options={{ useGrouping: false }}
          />
          <TextField source="user_id" label="ID User" />
          <TextField source="nome_usuario" label="Usuário" />
        </DatagridConfigurable>
      </List>
    </Stack>
  );
}
